import * as L from 'leaflet';
import * as Tangram from 'tangram';

export default {
  init() {
    this.drawPerciselyMap();
  },
  drawPerciselyMap() {
  
    //Set Map container and get the ID of the first map
    var initialMap = $('.precisely-map-inital');
    var mapId = $(initialMap).attr('id')
      
    //Define Map options
    var mapOptions = {
      zoomControl: false,
      scrollWheelZoom: false,
      touchZoom: false,
      attributionControl: false,
      trackResize: false,
      dragging: false,
    };

    //Initialise first map
    var map = L.map(mapId, mapOptions);

    var lat =  parseFloat($(initialMap).attr('data-lat'));
    var lng = parseFloat($(initialMap).attr('data-lng'));
    var zoom = 11;	
    map.setView([lat, lng], zoom);

    var tileLayer = Tangram.leafletLayer({scene: 'iron.yaml', attribution: '<a target="_blank" href="http://www.openstreetmap.org/copyright">&copy; OpenStreetMap contributors</a>'});

    //Set Marker icon
    var LeafIcon = L.Icon.extend({
      options: {
         iconSize:     [30, 55],
         iconAnchor:   [22, 94],
      },
  });

    var mapIcon = new LeafIcon({
      iconUrl: 'https://developer.precisely.com/assets/images/defaultmarker.svg',
    });

    map.addLayer(tileLayer);
    L.marker([lat, lng], {icon: mapIcon}).addTo(map);

    //On switching office set a new view for the map with the latidude and longitude of the office swithced to
    $('#office-selector').change(function () {
      const val = $(this).val()
      $('.office-details').hide();
      $('.office-details[data-office=' + val + ']').show();
      var office = $('div').find('[data-office="' + val + '"]'); 

      var lat =  parseFloat($(office).attr('data-lat'));
      var lng = parseFloat($(office).attr('data-lng'));
      map.setView([lat, lng], 11);

      //Set Marker icon
      var LeafIcon = L.Icon.extend({
        options: {
           iconSize:     [30, 55],
           iconAnchor:   [22, 94],
        },
    });
  
      var mapIcon = new LeafIcon({
        iconUrl: 'https://developer.precisely.com/assets/images/defaultmarker.svg',
      });

      L.marker([lat, lng], {icon: mapIcon}).addTo(map);
    });
  },
  enableTestProvince(enable) {
    $('#test-province').prop('disabled', !enable)
  },
  enableProvince(enable) {
    $('#province-select').toggle(enable)
    $('#province-select select').prop('disabled', !enable)
  },
  enableProvinceCanada(enable) {
    $('#province-select-canada').toggle(enable)
    $('#province-select-canada select').prop('disabled', !enable)
  },
  sendPostSuccessParam(redirectUrl) {
    $.post({
        url: redirectUrl,
        data: { formSuccess: true},
      })
      .done(function(data) {
        const iframe = '<iframe src="' + redirectUrl + '" width=0 height=0></iframe>'
        $('body').addClass('thank-you')
        $('body').html(data);
        $('body').append(iframe);
        $(window).scrollTop(0);
      })
  },
  storeUserDetails(serialisedData) {
    window.localStorage.setItem('precisely', JSON.stringify(serialisedData))
    /*$.ajax({
      type: 'POST',
      url: $('body').attr('data-ajax-url'),
      data: {
        data: serialisedData,
        action: 'saveDetails',
      },
    });*/
  },
  prepopulateForm() {
    if (window.localStorage.getItem('precisely')) {
      const data = JSON.parse(window.localStorage.getItem('precisely'))
      const fields = [
        'FirstName',
        'LastName',
        'Job_Title1',
        'Company',
        'EmailAddress',
        'BusPhone',
        'C_Country',
        'C_State_Prov',
      ]
      data.forEach(function (a) {
        if (fields.indexOf(a.name) >= 0) {
          $('form.contact-form input[name="' + a.name + '"], form.contact-form select[name="' + a.name + '"]').val(a.value).change()
        }
        if (a.name == 'confirmedEmailOptIn1' && a.value == 'TRUE') {
          $('form#contact-form input[name="confirmedEmailOptIn1"]').prop('checked', true);
          $('form#contact-form input[name="confirmedEmailOptIn1"]').parents('.form-group').hide()
        }
      })
    }
  },
  toggleMarketingEmail() {
    $('form.contact-form #country-select').change(function () {
      $('#marketingEmailOptIn').hide();
      if ($(this).children(':selected').attr('id') != 'country-usa' && $(this).children(':selected').attr('id') != 'country-france' && $(this).children(':selected').attr('id') != 'country-uk') {
        $('#marketingEmailOptIn').show()
      }
    });
  },
  checkStoredData() {
    let found = 0
    const data = JSON.parse(window.localStorage.getItem('precisely'))
    const fields = [
      'FirstName',
      'LastName',
      'Job_Title1',
      'Company',
      'EmailAddress',
      'BusPhone',
    ]

    if (data && data.length) {
      data.forEach(function (a) {
        if (fields.indexOf(a.name) >= 0 && a.value != '') {
          found++
        }
      })
      return (found == fields.length) ? true : false
    } else {
      return false
    }
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/locations.js